import { AppThunkAction, AppThunkDispatch } from '..';
import { clearBreadcrumbs, getStoredBreadcrumbs } from '../../utils';
import {
	PageType,
	IndexAction,
	Breadcrumb,
	IndexPageAction
} from './index.types';
export const INDEX_PUSH_PAGE: string = 'INDEX_PUSH_PAGE';
export const INDEX_RETURN_TO_PAGE: string = 'INDEX_RETURN_TO_PAGE';
export const INDEX_CLEAR_HISTORY: string = 'INDEX_CLEAR_HISTORY';

export function indexInitBreadcrumbs(): AppThunkAction<void, IndexAction> {
	return (dispatch: AppThunkDispatch<IndexAction>) => {
		const breadcrumbs: Breadcrumb[] = getStoredBreadcrumbs();
		breadcrumbs.forEach((breadcrumb) =>
			dispatch(
				indexPushPage(breadcrumb.type, breadcrumb.name, breadcrumb.id)
			)
		);
	};
}

export function indexPushPage(
	type: PageType,
	name: string,
	id: string
): IndexAction {
	const breadcrumb: Breadcrumb = {
		type,
		name,
		id
	};

	return { type: INDEX_PUSH_PAGE, payload: breadcrumb };
}

export function indexReturnToPage(pageId: string): IndexPageAction {
	return { type: INDEX_RETURN_TO_PAGE, payload: pageId };
}

export function indexClearHistory(): IndexAction {
	clearBreadcrumbs();
	return { type: INDEX_CLEAR_HISTORY };
}
